module.exports = __webpack_public_path__ + "img/expertise.3bc2005e.svg";